<template>

  <t-page>

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :set-tab-index="tabIndex"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default>

        <t-form-tab title="Modelo">

          <t-input v-model="form.typeChecklistId" hidden/>

          <t-form-card title="Dados Básicos">

            <t-input v-model="form.name" :add-error="error.name" label="Modelo de Inspeção" required/>

            <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

            <b-row>

              <t-input cols="6" radio required v-model="form.businessTypeSurvey"
                       :options="surveyTypeListByAccount" label="Tipo de Inspeção"/>

              <t-input cols="6" radio required v-model="form.defaultShareType"
                       help="Configuração padrão para novas inspeções vinculadas a este modelo. Com a opção pública será possível enviar um link com todas as fotos da inspeção para download."
                       :options="ChecklistShareType.list" label="Compartilhamento Fotos"/>

            </b-row>


            <t-input-status v-model="form.status"/>

          </t-form-card>

          <t-form-card title="Regras de Negócio - Geral">


            <b-form-checkbox v-model="form.businessShowEvidenceFields" class="mb-3" switch>
              Habilitar exibição de campos detalhados de fotos da aba inspeção (além da legenda)?
              <t-help
                  title="Utilize esta opção quando desejar que o app direcione para o formulário detalhado após a inclusão de fotos na aba inspeção, para sejam preenchidas informações adicionais além da legenda da foto."/>

            </b-form-checkbox>


            <table class="mb-0 mt-2 table table-striped" v-if="form.businessShowEvidenceFields" style="max-width: 760px">
              <thead>
              <tr>
                <th>Exibir</th>
                <th>Campo</th>
                <th style="width: 90px;">Ordem <t-help title="Sequência desejada para o preenchimento do formulário no app/web no momento do registro das imagens" /></th>
                <th>Obrigar</th>
              </tr>
              </thead>

              <tbody>

              <!-- Categoria -->
              <tr>
                <td>
                  <b-form-checkbox
                      v-model="businessEvidenceFileRequiredFieldsObject.categoryShow"/>
                </td>

                <td>
                  <b-form-input
                      size="sm"
                      :disabled="!businessEvidenceFileRequiredFieldsObject.categoryShow"
                      v-model="businessEvidenceFileRequiredFieldsObject.categoryLabel"
                      placeholder="Categoria"/>
                </td>

                <td>
                  <b-form-input
                      size="sm"
                      type="number"
                      min="1"
                      :disabled="!businessEvidenceFileRequiredFieldsObject.categoryShow"
                      v-model.number="businessEvidenceFileRequiredFieldsObject.categoryOrder"/>
                </td>

                <td>
                  <b-form-checkbox
                      :disabled="!businessEvidenceFileRequiredFieldsObject.categoryShow"
                      v-model="businessEvidenceFileRequiredFieldsObject.categoryRequired"/>
                </td>
              </tr>

              <!-- Serviço -->
              <tr>
                <td>
                  <b-form-checkbox
                      v-model="businessEvidenceFileRequiredFieldsObject.serviceShow"/>
                </td>

                <td>
                  <b-form-input
                      size="sm"
                      :disabled="!businessEvidenceFileRequiredFieldsObject.serviceShow"
                      v-model="businessEvidenceFileRequiredFieldsObject.serviceLabel"
                      placeholder="Serviço"/>
                </td>

                <td>
                  <b-form-input
                      size="sm"
                      type="number"
                      min="1"
                      :disabled="!businessEvidenceFileRequiredFieldsObject.serviceShow"
                      v-model.number="businessEvidenceFileRequiredFieldsObject.serviceOrder"/>
                </td>

                <td>
                  <b-form-checkbox
                      :disabled="!businessEvidenceFileRequiredFieldsObject.serviceShow"
                      v-model="businessEvidenceFileRequiredFieldsObject.serviceRequired"/>
                </td>
              </tr>

              <!-- Status -->
              <tr>
                <td>
                  <b-form-checkbox
                      v-model="businessEvidenceFileRequiredFieldsObject.statusShow"/>
                </td>

                <td>
                  <b-form-input
                      size="sm"
                      :disabled="!businessEvidenceFileRequiredFieldsObject.statusShow"
                      v-model="businessEvidenceFileRequiredFieldsObject.statusLabel"
                      placeholder="Status"/>
                </td>

                <td>
                  <b-form-input
                      size="sm"
                      type="number"
                      min="1"
                      :disabled="!businessEvidenceFileRequiredFieldsObject.statusShow"
                      v-model.number="businessEvidenceFileRequiredFieldsObject.statusOrder"/>
                </td>

                <td>
                  <b-form-checkbox
                      :disabled="!businessEvidenceFileRequiredFieldsObject.statusShow"
                      v-model="businessEvidenceFileRequiredFieldsObject.statusRequired"/>
                </td>
              </tr>

              <!-- Detalhe do Ambiente -->
              <tr>
                <td>
                  <b-form-checkbox
                      v-model="businessEvidenceFileRequiredFieldsObject.complementShow"/>
                </td>

                <td>
                  <b-form-input
                      size="sm"
                      :disabled="!businessEvidenceFileRequiredFieldsObject.complementShow"
                      v-model="businessEvidenceFileRequiredFieldsObject.complementLabel"
                      placeholder="Detalhe do Ambiente"/>
                </td>

                <td>
                  <b-form-input
                      size="sm"
                      type="number"
                      min="1"
                      :disabled="!businessEvidenceFileRequiredFieldsObject.complementShow"
                      v-model.number="businessEvidenceFileRequiredFieldsObject.complementOrder"/>
                </td>

                <td>
                  <b-form-checkbox
                      :disabled="!businessEvidenceFileRequiredFieldsObject.complementShow"
                      v-model="businessEvidenceFileRequiredFieldsObject.complementRequired"/>
                </td>
              </tr>

              </tbody>
            </table>

          </t-form-card>

          <t-form-card title="Regras de Negócio - Apontamentos"
                       v-if="(checklistModelOccurrenceEnabled || checklistModelOccurrenceBudgetEnabled) && form.businessTypeSurvey >= SurveyType.type.OCCURRENCE">

            <div>Especifique a qtd. mínima desejada de fotos para apontamentos <b>novos</b>:
              <t-help title="Deixe como 0(zero) caso não desejar exigir fotos mínimas no apontamento novo"/>
            </div>
            <t-input v-model="form.businessOccurrenceNewQtyMinPhotos" accept-zero max-length="2" number
                     style="max-width: 150px"/>


            <div>Especifique a qtd. mínima desejada de fotos para apontamentos <b>em andamento</b>:
              <t-help title="Deixe como 0(zero) caso não desejar exigir fotos mínimas no apontamento pendente"/>
            </div>
            <t-input v-model="form.businessOccurrencePendingQtyMinPhotos" accept-zero max-length="2" number
                     style="max-width: 150px"/>


            <div>Especifique a qtd. mínima desejada de fotos para <b>finalização</b> de apontamentos:
              <t-help title="Deixe como 0(zero) caso não desejar exigir fotos mínimas no apontamento finalizado"/>
            </div>
            <t-input v-model="form.businessOccurrenceCloseQtyMinPhotos" accept-zero max-length="2" number
                     style="max-width: 150px"/>


            <div class="divider"></div>

            <b-form-checkbox v-model="form.businessOccurrenceFinishAfterOpen" switch>
              Habilitar finalização de apontamentos automaticamente?
              <t-help title="Utilize esta opção quando não desejar controlar o status dos apontamentos, fazendo com que o
                mesmos são finalizados automaticamente após a finalização."/>
            </b-form-checkbox>


          </t-form-card>


          <t-form-card title="Relatório de Apontamentos"
                       v-if="(checklistModelOccurrenceEnabled || checklistModelOccurrenceBudgetEnabled) && form.businessTypeSurvey >= SurveyType.type.OCCURRENCE">

            <b-form-checkbox v-model="form.reportOccurrenceDefaultSend" switch>
              Enviar relatório de apontamentos (caso existirem apontamentos) com cópia para inspetor e o responsável
              (caso configurado) após término da inspeção?
            </b-form-checkbox>

            <b-form-checkbox class="mt-2 mb-2" v-model="form.reportOccurrenceDefaultHideHeaderFooter" switch>
              Ocultar todas as informações do cabeçalho e rodapé?
            </b-form-checkbox>

            <b-row>

              <b-col cols="12" class="pb-2">

                <b-form-checkbox v-model="form.reportOccurrenceDefaultByCriticality" switch>
                  Exibir status de cores por tipo de criticidade?
                  <t-help title="Utilize esta opção quando desejar informar os apontamentos por criticidade escolhida"/>
                </b-form-checkbox>

              </b-col>


            </b-row>


            <b-row>
              <t-input v-model="form.reportOccurrenceDefaultTitle" cols="6" label="Título Padrão"/>
              <t-input v-model="form.reportOccurrenceDefaultSubtitle" cols="6" label="Subtítulo Padrão"/>
            </b-row>


            <b-row>

              <t-input cols="6" v-model="form.reportOccurrenceDefaultLayout" required stacked
                       :options="ReportOccurrenceLayoutType.list"
                       radio
                       label="Layout padrão"/>

              <t-input cols="6" radio required stacked v-model="form.reportOccurrenceDefaultGraphic"
                       :options="ReportOccurrenceGraphicType.list" label="Gráficos"/>

            </b-row>

            <b-row>

              <!--              <t-input cols="6" v-model="form.reportOccurrenceDefaultEnvironmentSort" required stacked
                                     :options="ReportEnvironmentSortType.list"
                                     radio
                                     label="Ordenação dos ambientes"/>-->


              <b-col cols="12">

                <t-input radio required stacked v-model="form.reportOccurrenceDefaultHeaderPositionLogo"
                         :options="ReportPositionLogoHeaderType.list" label="Cabeçalho logomarca"/>

                <b-form-checkbox class="ml-2" :disabled="form.reportOccurrenceDefaultHideHeaderFooter"
                                 v-model="form.reportOccurrenceDefaultHeaderLogoAllPages" switch>
                  Exibir logomarca e dados de contato em todas as páginas?
                  <t-help
                      title="Caso desmarcar irá exibir somente na primeira página. Disponível configuração somente se estiver hábilitado as informações de cabeçalho e rodapé."/>
                </b-form-checkbox>

              </b-col>


            </b-row>


          </t-form-card>

          <t-form-card title="Relatório Fotográfico (aba registro)">

            <!--            <t-msg info>Informações para complemento de informações e emissão dos relatório de evolução</t-msg>

            <b-form-checkbox v-model="form.reportEvidenceDefaultSend" switch>
              Enviar relatório fotográfico (caso existirem imagens novas) com cópia para inspetor e o responsável
              (caso configurado) após término da inspeção?
            </b-form-checkbox>

            <b-form-checkbox class="mt-2 mb-2" v-model="form.reportEvidenceShowCover" switch>
              Exibir capa?
            </b-form-checkbox>

            <b-form-checkbox class="mt-2 mb-2" v-model="form.reportEvidenceDefaultHideHeaderFooter" switch>
              Ocultar todas informações do cabeçalho e rodapé?
            </b-form-checkbox>


            <b-form-checkbox class="mt-2 mb-2" v-model="form.reportEvidenceDefaultHideSpotFolderDivision" switch>
              Ocultar Título com a Divisão e Pavimento?
            </b-form-checkbox>

               <b-form-checkbox class="mt-2 mb-2" v-show="!form.reportEvidenceDefaultHideSpotFolderDivision"
                             v-model="form.reportEvidenceBreakPageBySpotFolder" switch>
              Habilitar quebra de página por pavimento?
            </b-form-checkbox>

  -->
            <b-form-checkbox class="mt-2 mb-2" v-model="form.reportEvidenceDefaultHideEnvironment" switch>
              Ocultar Título com nome do Ambiente
            </b-form-checkbox>



            <t-input v-model="form.reportEvidenceDefaultTitle" help="Utilizado em alguns estilos de relatório" label="Título Padrão"/>

            <!--
            <b-row>
             <t-input v-model="form.reportEvidenceDefaultSubtitle" cols="6" label="Subtítulo Padrão"/>
            </b-row>
            -->

            <b-row class="mb-2">

              <t-input cols="6" v-model="form.reportEvidenceDefaultLayout" required stacked
                       :options="ReportEvidenceLayoutType.list"
                       radio
                       label="Layout padrão"/>

              <b-col cols="6">

                <t-input radio required stacked v-model="form.reportEvidenceDefaultDesignType"
                         :options="ReportEvidenceDesignType.list" label="Design preferido"/>

                <!--
                <t-input radio required stacked v-model="form.reportEvidenceDefaultHeaderPositionLogo"
                         :options="ReportPositionLogoHeaderType.list" label="Cabeçalho logomarca"/>

                <b-form-checkbox class="ml-2" :disabled="form.reportEvidenceDefaultHideHeaderFooter"
                                 v-model="form.reportEvidenceDefaultHeaderLogoAllPages" switch>
                  Exibir logomarca e dados de contato em todas as páginas?
                  <t-help
                      title="Caso desmarcar irá exibir somente na primeira página. Disponível configuração somente se estiver hábilitado as informações de cabeçalho e rodapé."/>
                </b-form-checkbox>

                -->

              </b-col>


            </b-row>

            <b-row>

              <t-input radio required stacked cols="4" v-model="form.reportEvidenceDefaultSubtitleFormat"
                       :options="ReportSubtitleType.list" label="Formato das legendas"/>


              <t-input label="Alterar rótulo 'Fotos'" cols="4" placeholder="Padrão: Foto" small="Escolha algo fora do padrão como por exemplo: 'Imagem'" v-model="form.reportEvidenceDefaultSequenceOtherLabel" />

              <t-input cols="4" v-model="form.reportEvidenceDefaultEnvironmentSort" required stacked
                       :options="ReportEnvironmentSortType.list"
                       radio
                       label="Ordenação das fotos"/>

            </b-row>

            <b-form-checkbox class="mt-2 mb-2" v-model="form.reportEvidenceDefaultSubtitleUpperCase" switch>
              Texto da legenda em MAIÚSCULO
              <t-help title="Marque caso desejar converter o texto da legenda maiúscula"/>
            </b-form-checkbox>


            <b-row v-if="accountModule === 'estate'">

              <t-input cols="6" v-model="form.estateDefaultIntroText" textarea max-length="2000"
                       label="Texto Padrão de Introdução no laudo"
                       small="Servirá como padrão para novas inspeções para este modelo, porém poderá ser modificado livremente."/>

              <t-input cols="6" v-model="form.estateDefaultFinishText" textarea max-length="2000"
                       label="Texto Padrão de Encerramento no laudo"
                       small="Servirá como padrão para novas inspeções para este modelo, porém poderá ser modificado livremente."/>


            </b-row>


          </t-form-card>

          <t-form-card title="Atividades">

            <div v-if="activityOptions.length > 0">

              <t-msg info>Selecione abaixo, caso desejar exigir atividades adicionais ao realizar um checklist deste
                tipo
              </t-msg>

              <b-row v-for="activity in activityOptions" :key="activity.typeActivityId" class="pb-2 mb-2 border-bottom">

                <b-col cols="12">

                  <b-form-checkbox class="ml-3"
                                   :checked="form.activities.find(a => a.typeActivityId === activity.value) != null"
                                   @change="addActivitySelected($event,activity.value)">
                    <b>{{ activity.text }}</b>
                  </b-form-checkbox>

                  <b-row class="p-3 ml-4">

                    <b-form-checkbox class="col-sm-12 mb-2"
                                     v-if="form.activities.find(a => a.typeActivityId === activity.value) != null"
                                     v-model="form.activities.find(a => a.typeActivityId === activity.value).required"
                                     switch>
                      Exigir o preenchimento?
                      <t-help title="Você poderá exigir o preenchimento obrigatóriamente sempre que uma inspeção deste tipo de
                        checklist for realizada. Caso contrário será uma atividade opcional."/>

                    </b-form-checkbox>

                    <b-form-checkbox class="col-sm-12 mb-2"
                                     v-if="form.activities.find(a => a.typeActivityId === activity.value) != null"
                                     v-model="form.activities.find(a => a.typeActivityId === activity.value).enableCopyLastActivity"
                                     switch>
                      Permitir copiar os dados da última atividade?
                      <t-help
                          title="Caso habilitado o inspetor poderá realizar a cópia dos dados da última atividade"/>
                    </b-form-checkbox>

                    <b-form-checkbox class="col-sm-12 mb-2"
                                     v-if="form.activities.find(a => a.typeActivityId === activity.value) != null && form.activities.find(a => a.typeActivityId === activity.value).enableCopyLastActivity"
                                     v-model="form.activities.find(a => a.typeActivityId === activity.value).enableAutoCopy"
                                     switch>
                      Realizar a cópia automaticamente na instalação do checklist?
                      <t-help
                          title="Caso habilitado o sistema irá realizar a cópia da última atividade preenchida automaticamente e mesmo que o checklist de origem não tenha sido finalizado, porém o inspetor deverá ainda finalizar a atividade confirmando ou editando os dados que desejar."/>
                    </b-form-checkbox>

                    <t-input textarea label="Deseja inserir alguma orientação de preenchimento aos inspetores?"
                             v-if="form.activities.find(a => a.typeActivityId === activity.value) != null"
                             v-model="form.activities.find(a => a.typeActivityId === activity.value).note"/>

                  </b-row>

                </b-col>


              </b-row>

            </div>

            <t-msg v-else info>Atividades são formulários adicionais que podem ser vinculados a um modelo de inspeção.
              No
              momento não há nenhuma atividade habilitada na sua conta, caso desejar habilitar por favor entre em
              contato com a
              Onlaine para saber mais.
            </t-msg>

          </t-form-card>


        </t-form-tab>

        <!--
        <t-form-tab title="Empreendimentos" hash="enterprise">

          <b-form-checkbox class="col-sm-12 ml-2 mb-3" @change="getAllEnterprises()" v-model="form.enableAllEnterprises"
                           switch>
            Habilitar todos os empreendimentos para este modelo?
            <t-help
                title="Você poderá especificar quais os locais desejados, basta desmarcar esta opção e especificar quais os locais abaixo."/>
          </b-form-checkbox>

          <t-msg
              v-if="form.enableAllEnterprises"
              info>
            Caso desejar especificar os locais, desmarque a opção acima para escolha.
          </t-msg>

          <t-msg
              v-else-if="!form.enableAllEnterprises && enterprisesList.length === 0"
              warning>
            Nenhum local encontrado
          </t-msg>

          <t-table
              v-else
              enable-checked
              v-model="enterprisesIds"
              :items="enterprisesList"
              :fields="viewFieldsPageEnterprise"
              @change="changeEnterprise"
              title-items="local"
              link-primary-column="enterpriseCodeLabel"
              class="mb-3"
              table-bordered
              disable-actions-column
              primary-key-column="enterpriseId">

            <template #first-column="{item}">
              {{ item.enterpriseCodeLabel }}
            </template>

          </t-table>

        </t-form-tab>
        -->


        <!--        <t-form-tab title="Ambientes" hash="environment">

                  <div v-if="!form.enableAllEnterprises && enterprisesIds.length === 1">

                    <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="form.enableAllEnvironments" switch>
                      Inspeçãor todos os ambientes do local?
                      <t-help
                          title="Você poderá especificar quais os ambientes desejados, basta desmarcar esta opção e especificar quais os ambientes abaixo."/>
                    </b-form-checkbox>

                    <t-msg
                        v-if="form.enableAllEnvironments"
                        info>
                      Caso desejar especificar os ambientes, desmarque a opção acima para escolha.
                    </t-msg>

                    <t-msg
                        v-else-if="!form.enableAllEnvironments && environmentsList.length === 0"
                        warning>
                      Nenhum ambiente encontrado para este local escolhido
                    </t-msg>

                    <t-table
                        v-else
                        enable-checked
                        v-model="environmentsIds"
                        :items="environmentsList"
                        :fields="viewFieldsPageEnvironment"
                        title-items="ambiente"
                        link-primary-column="name"
                        class="mb-3"
                        table-bordered
                        disable-actions-column
                        primary-key-column="environmentId">

                      <template #first-column="{item}">
                        {{ item.name }}
                      </template>

                    </t-table>

                  </div>

                  <t-msg
                      v-else
                      info>
                    Caso desejar especificar os ambientes, selecione somente um empreendimento desejado na aba 'Empreendimentos'
                  </t-msg>

                </t-form-tab>-->

        <t-form-tab title="Disciplinas" hash="sector">

          <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="form.enableAllSectors" switch>
            Inspeçãor todos os itens de todos as disciplinas?
            <t-help
                title="Você poderá especificar quais os categorias desejados, basta desmarcar esta opção e especificar quais os setores abaixo."/>
          </b-form-checkbox>

          <t-msg
              v-if="form.enableAllSectors"
              info>
            Caso desejar especificar os categorias relacionados as anomalias, desmarque a opção acima.
          </t-msg>

          <t-msg
              v-else-if="!form.enableAllSectors && sectorsList.length === 0"
              warning>
            Nenhum setor encontrado para especificação. Cadastre setores através do menu Agentes > Sistemaes
          </t-msg>

          <t-table
              v-else
              enable-checked
              v-model="sectorsIds"
              :items="sectorsList"
              :fields="viewFieldsPageSector"
              title-items="setor"
              link-primary-column="name"
              class="mb-3"
              table-bordered
              disable-actions-column
              primary-key-column="sectorId">

            <template #first-column="{item}">
              {{ item.name }}
            </template>

          </t-table>

        </t-form-tab>

        <t-form-tab title="Categorias" hash="category">

          <b-form-checkbox class="col-sm-12 ml-2 mb-3" v-model="form.enableAllEvidenceCategory" switch>
            Habiltiar todas as categorias de evidências para este modelo de inspeção?
            <t-help
                title="Você poderá especificar quais as categorias para evolução de obra desejadas, basta desmarcar esta opção e especificar quais as categorias abaixo."/>
          </b-form-checkbox>

          <t-msg
              v-if="form.enableAllEvidenceCategory"
              info>
            Caso desejar especificar os setores relacionados as anomalias, desmarque a opção acima.
          </t-msg>

          <t-msg
              v-else-if="!form.enableAllEvidenceCategory && evidenceCategoriesList.length === 0"
              warning>
            Nenhuma categoria encontrada para especificação. Cadastre categorias através do menu Inspeções >
            Configurações > Categorias de Evidências.
          </t-msg>

          <t-table
              v-else
              enable-checked
              v-model="evidenceCategoriesIds"
              :items="evidenceCategoriesList"
              :fields="viewFieldsPageEvidenceCategory"
              title-items="categorias"
              link-primary-column="name"
              class="mb-3"
              table-bordered
              disable-actions-column
              primary-key-column="typeEvidenceCategoryId">

            <template #first-column="{item}">
              {{ item.name }}
            </template>

          </t-table>

        </t-form-tab>

      </template>

      <template #out-of-form>

        <!--
        <t-form-tab title="Campos Especiais" hash="custom-field"
                    :disabled="!relationAccessPageGeneral('checklist-type-model-environment-field')"
                    lazy>
          <TypeChecklistModelField :foreign-key="form[fieldKey]"/>
        </t-form-tab>
        -->

      </template>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageViewService from "@/services/modules/setting/PageView.service";
import EnvironmentService from "@/services/modules/place/Environment.service";
import SectorService from "@/services/modules/agent/Sector.service";
import EnterpriseService from "@/services/modules/place/Enterprise.service";
import TypeChecklistActivityService from "@/services/modules/checklist/TypeChecklistActivity.service";
import TypeEvidenceCategory from "@/services/modules/checklist/TypeEvidenceCategory.service";
/*import TypeChecklistModelField from "@/views/modules/checklist/TypeChecklistModelField";*/
import ui from "@/assets/scripts/ui";
import ReportEvidenceLayoutType from "@/model/types/modules/checklist/ReportEvidenceLayoutType";
import ReportPositionLogoHeaderType from "@/model/types/modules/checklist/ReportPositionLogoHeaderType";
import ReportEnvironmentSortType
  from "@/model/types/modules/checklist/ReportEnvironmentSortType";
import ReportSubtitleType from "@/model/types/modules/checklist/ReportSubtitleType";
import ReportOccurrenceLayoutType from "@/model/types/modules/checklist/ReportOccurrenceLayoutType";
import ReportOccurrenceGraphicType from "@/model/types/modules/checklist/ReportOccurrenceGraphicType";
import SurveyType from "@/model/types/modules/checklist/SurveyType";
import ChecklistShareType from "@/model/types/modules/checklist/ChecklistShareType";
import checklistService from "@/services/modules/checklist/Checklist.service";
import ReportEvidenceDesignType from "@/model/types/modules/checklist/ReportEvidenceDesignType";
import BusinessEvidenceFileEntity from "@/model/entities/modules/checklist/BusinessEvidenceFileEntity";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  /*  components: {TypeChecklistModelField},*/
  name: 'TypeChecklistModelForm',
  data() {
    return {
      ChecklistShareType,
      SurveyType,
      ReportEvidenceLayoutType,
      ReportPositionLogoHeaderType,
      ReportEnvironmentSortType,
      ReportOccurrenceLayoutType,
      ReportOccurrenceGraphicType,
      ReportSubtitleType,
      ReportEvidenceDesignType,
      path: "", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      fieldKey: "typeChecklistId",
      form: {
        typeChecklistId: 0,
        typeChecklistNumber: 0,
        enterpriseId: 0,
        name: "",
        enableAllEnterprises: true,
        enableAllEnvironments: true,
        enableAllSectors: true,
        enableAllEvidenceCategory: true,
        estateDefaultIntroText: "",
        estateDefaultFinishText: "",
        businessEnvironmentRequiredJustification: false,
        businessTypeSurvey: SurveyType.type.OCCURRENCE,
        businessShowEvidenceFields: false,
        businessEvidenceFileRequiredFields: "N",
        businessEvidenceQtyMinPhotos: 0,
        businessOccurrenceNewQtyMinPhotos: 1,
        businessOccurrencePendingQtyMinPhotos: 0,
        businessOccurrenceCloseQtyMinPhotos: 0,
        businessOccurrenceFinishAfterOpen: false,
        reportEvidenceDefaultTitle: "",
        reportEvidenceDefaultSubtitle: "",
        reportEvidenceDefaultLayout: ReportEvidenceLayoutType.type.BASIC_4_PHOTOS_PORTRAIT,
        reportEvidenceDefaultHeaderPositionLogo: ReportPositionLogoHeaderType.type.LEFT,
        reportEvidenceDefaultHeaderLogoAllPages: true,
        reportEvidenceDefaultHideHeaderFooter: false,
        reportEvidenceDefaultHideSpotFolderDivision: true,
        reportEvidenceDefaultHideEnvironment: false,
        reportEvidenceDefaultEnvironmentSort: ReportEnvironmentSortType.type.DEFAULT,
        reportEvidenceDefaultSubtitleFormat: ReportSubtitleType.type.BASIC,
        reportEvidenceBreakPageBySpotFolder: false,
        reportEvidenceDefaultSend: false,
        reportEvidenceDefaultDesignType: ReportEvidenceDesignType.type.DEFAULT,
        reportEvidenceDefaultSequenceOtherLabel: "Foto",
        reportEvidenceDefaultSubtitleUpperCase:false,
        reportEvidenceShowCover: true,
        reportOccurrenceDefaultSend: true,
        reportOccurrenceDefaultTitle: "",
        reportOccurrenceDefaultSubtitle: "",
        reportOccurrenceDefaultLayout: ReportOccurrenceLayoutType.type.ONLY_FIRST_PHOTO,
        reportOccurrenceDefaultGraphic: ReportOccurrenceGraphicType.type.BASIC,
        reportOccurrenceDefaultHideHeaderFooter: false,
        reportOccurrenceDefaultByCriticality: false,
        reportOccurrenceDefaultHeaderPositionLogo: ReportPositionLogoHeaderType.type.LEFT,
        reportOccurrenceDefaultHeaderLogoAllPages: true,
        reportOccurrenceDefaultEnvironmentSort: ReportEnvironmentSortType.type.DEFAULT,
        reportOccurrenceDefaultSubtitleFormat: ReportSubtitleType.type.FULL,
        enterprises: [],
        activities: [],
        environments: [],
        sectors: [],
        evidenceCategories: [],
        defaultShareType: ChecklistShareType.type.NOT,
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        enterpriseId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      accountModule: "",
      activityOptions: [],
      businessEvidenceFileRequiredFieldsObject: new BusinessEvidenceFileEntity(),
      tabIndex: 0,
      enterprisesIds: [],
      enterprisesList: [],
      viewFieldsPageEnterprise: [],
      environmentsIds: [],
      environmentsList: [],
      viewFieldsPageEnvironment: [],
      sectorsIds: [],
      sectorsList: [],
      viewFieldsPageSector: [],
      evidenceCategoriesIds: [],
      evidenceCategoriesList: [],
      viewFieldsPageEvidenceCategory: [],
      surveyTypeListByAccount: [],
      checklistModelEvidenceEnabled: false,
      checklistModelOccurrenceBudgetEnabled: false,
      checklistModelOccurrenceEnabled: false,
      checklistModelCondoEnabled: false,
      checklistModelEstateEnabled: false,
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.accountModule = ui.getAccountModule()

    },
    async mountedContinued() {

      await TypeChecklistActivityService.selectList().then((list) => {
        this.activityOptions = list
      }).catch(error => this.responseError(error))

      await pageViewService.getViewFieldsByPage(192, true, [""]).then((response) => {
        this.viewFieldsPageEnterprise = response
      }).catch(error => this.responseError(error))

      await pageViewService.getViewFieldsByPage(197, true, ["enterprise"]).then((response) => {
        this.viewFieldsPageEnvironment = response
      }).catch(error => this.responseError(error))

      await pageViewService.getViewFieldsByPage(193, true, [""]).then((response) => {
        this.viewFieldsPageSector = response
      }).catch(error => this.responseError(error))

      await this.getAllEnterprises()

      await SectorService.getAllSectors().then((list) => {
        this.sectorsList = list
        this.sectorsIds = this.convertObjectToArrayIds(this.form.sectors, "sectorId")
      }).catch(error => this.responseError(error))

      await TypeEvidenceCategory.getAllCategories().then((list) => {
        this.evidenceCategoriesList = list
        this.evidenceCategoriesIds = this.convertObjectToArrayIds(this.form.evidenceCategories, "typeEvidenceCategoryId")
      }).catch(error => this.responseError(error))

      await this.changeEnterprise()


      /*Filtros de modelos de acordo com a conta*/
      this.surveyTypeListByAccount = SurveyType.list

      this.checklistModelEvidenceEnabled = this.getRenderRule('checklistModelEvidenceEnabled')
      this.checklistModelOccurrenceEnabled = this.getRenderRule('checklistModelOccurrenceEnabled')
      this.checklistModelEstateEnabled = this.getRenderRule('checklistModelEstateEnabled')
      this.checklistModelCondoEnabled = this.getRenderRule('checklistModelCondoEnabled')
      this.checklistModelOccurrenceBudgetEnabled = this.getRenderRule('checklistModelOccurrenceBudgetEnabled')

      if (!this.checklistModelEvidenceEnabled) {
        this.surveyTypeListByAccount = this.surveyTypeListByAccount.filter(item => item.value !== SurveyType.type.EVIDENCE);
      }

      if (!this.checklistModelOccurrenceEnabled) {
        this.surveyTypeListByAccount = this.surveyTypeListByAccount.filter(item => item.value !== SurveyType.type.OCCURRENCE);
      }

      if (!this.checklistModelEstateEnabled) {
        this.surveyTypeListByAccount = this.surveyTypeListByAccount.filter(item => item.value !== SurveyType.type.ESTATE);
      }

      if (!this.checklistModelCondoEnabled) {
        this.surveyTypeListByAccount = this.surveyTypeListByAccount.filter(item => item.value !== SurveyType.type.CONDO);
      }

      if (!this.checklistModelOccurrenceBudgetEnabled) {
        this.surveyTypeListByAccount = this.surveyTypeListByAccount.filter(item => item.value !== SurveyType.type.BUDGET);
      }
      /*----------*/
      this.businessEvidenceFileRequiredFieldsObject = checklistService.onBusinessEvidenceFileRequiredFieldsFromString(this.form.businessEvidenceFileRequiredFields, this.form.businessEvidenceFileLabelOrderFields)

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      this.form.enterprises = this.convertArrayIdsToObject(this.enterprisesIds, "enterpriseId")
      this.form.environments = this.convertArrayIdsToObject(this.environmentsIds, "environmentId")
      this.form.sectors = this.convertArrayIdsToObject(this.sectorsIds, "sectorId")
      this.form.evidenceCategories = this.convertArrayIdsToObject(this.evidenceCategoriesIds, "typeEvidenceCategoryId")




      this.form.businessEvidenceFileRequiredFields = checklistService.onBusinessEvidenceFileRequiredFieldsToString(this.businessEvidenceFileRequiredFieldsObject)
      this.form.businessEvidenceFileLabelOrderFields = checklistService.onBusinessEvidenceFileLabelOrderFieldsToString(this.businessEvidenceFileRequiredFieldsObject)

      //Consistência de informações
      if (this.form.enableAllEnterprises || this.form.enterprises.length > 1) {
        this.form.enableAllEnvironments = true
      }

      if (!this.form.enableAllEnterprises && this.form.enterprises.length === 1 && !this.form.enableAllEnvironments && this.form.environments.length === 0) {
        ui.msgError(this, "Selecione pelo menos 1 ambiente ou desmarque a opção de especificar os ambientes.", () => {
          this.tabIndex = 1
        })
      } else if (!this.form.enableAllSectors && this.form.sectors.length === 0) {
        ui.msgError(this, "Selecione pelo menos 1 setor ou desmarque a opção de especificar os setores", () => {
          this.tabIndex = 1
        })

      } else {
        await this.setSendingDefault()
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    async getAllEnterprises() {

      if (!this.form.enableAllEnterprises) {

        this.pageFormIsLoaded = false

        await EnterpriseService.getAllEnterprises().then((list) => {
          this.enterprisesList = list
          this.enterprisesIds = this.convertObjectToArrayIds(this.form.enterprises, "enterpriseId")
        }).catch(error => this.responseError(error))

        this.pageFormIsLoaded = true

      }

    },

    async changeEnterprise() {

      if (this.enterprisesIds.length === 1) {

        await EnvironmentService.getAllEnvironmentByEnterpriseId(this.enterprisesIds[0]).then((list) => {
          this.environmentsList = list
          this.environmentsIds = this.convertObjectToArrayIds(this.form.environments, "environmentId")
        }).catch(error => this.responseError(error))

      }

    },

    addActivitySelected(checked, id) {

      if (checked) {
        //Adicionar
        const el = this.form.activities.find(a => a.typeActivityId === id)
        if (el == null)
          this.form.activities.push({
            typeActivityId: id,
            required: false,
            note: '',
            enableCopyLastActivity: false,
            enableAutoCopy: false
          })
      } else {
        //Remover
        const indexRemove = this.form.activities.findIndex(a => a.typeActivityId === id)

        if (indexRemove >= 0)
          this.form.activities.splice(indexRemove, 1)

      }

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  }

}
</script>

